// extracted by mini-css-extract-plugin
module.exports = {"pre":"CodeBlock_pre__YzF9N","code":"CodeBlock_code__21eYT"};